/* Handmade by Rosie — delivery progress, stitched names and tagged little extras.
 * Shopify owns prices and delivery eligibility. This code never applies a discount.
 */
(() => {
  'use strict';
  if (window.HbrBagUpgrade) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const normalise = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g,'');
  const amount = value => Number.isSafeInteger(value) && value >= 0 ? value : null;
  const route = path => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/') + path;
  const safeURL = value => {
    try {
      if (!value) return '';
      const url = new URL(typeof value === 'object' ? value.src || value.url : value, location.origin);
      return /^https?:$/.test(url.protocol) ? escape(url.href) : '';
    } catch { return ''; }
  };
  const YARN = [
    ['1 · Pink','#E5A6B4'], ['2 · Blue','#A9C9DC'], ['3 · Cream','#F0E8D8'],
    ['4 · Rose','#CF8E9B'], ['5 · Ocean','#4D98CF'], ['6 · Brown','#89634D'],
    ['7 · Beige','#D5BDA4'], ['8 · Grass','#639166'], ['9 · Purple','#9D80C1'],
    ['10 · Navy Blue','#24375C'], ['11 · Brick','#A84F3B'], ['12 · Grey','#B3B4B4'],
    ['13 · Black','#252221'], ['14 · Green','#75A886'], ['15 · Yellow','#E7C45E'],
    ['16 · Orange','#E87832'], ['17 · Mint Green','#A8D2BE']
  ];
  const THREAD = [
    ['White','#F4F2F0'], ['Black','#1F1D1D'], ['Light Brown','#C78E78'],
    ['Cream','#EED8B6'], ['Yellow','#F2C500'], ['Gold','#DEA019'], ['Orange','#ED511E'],
    ['Brown','#95664D'], ['Coffee','#66362D'], ['Dark Brown','#47251F'],
    ['Coral','#EA7466'], ['Bright Pink','#DE638F'], ['Light Pink','#E8A4B9'],
    ['Dark Pink','#C51D62'], ['Rose Red','#C9004A'], ['Light Purple','#A45CCB'],
    ['Purple','#6C1FA2'], ['Dark Red','#9A1237'], ['Red','#D91B24'], ['Teal','#16898D'],
    ['Light Blue','#9BBBD7'], ['Lake','#19A6B7'], ['Sky Blue','#4A91CF'],
    ['Royal','#164B9D'], ['Dark Blue','#23245B'], ['Gray','#8C8992'],
    ['Dark Gray','#50505A'], ['Army Green','#6A6B2B'], ['Fruit Green','#158B4B'],
    ['Dark Green','#174A34']
  ];
  // Keep in step with threadSchemes and data-hbr-thread in handmade-product.liquid.
  const SCHEMES = {
    N01:['#ecb9c7','#edcd8d','#a6c7d4','#d59db0','#bbd7de'],
    N02:['#8ec2c5','#91aec3','#b0d2ce','#9aadc2','#9dc9cb'],
    N03:['#ca8793','#e4d3ad','#dfafa5'],
    N04:['#4f806d','#75a088','#9bb6a2','#5d8b73','#86aa96'],
    N05:['#f0e5ca','#d7bd98','#b58c67','#e5d2b0','#9f704e'],
    N06:['#ba5966','#4d9aa2','#d2a24f','#da7c83','#72827a'],
    // Halloween letter sequences from hbr_halloween_schemes in the product section.
    H01:['#EE7620','#252221','#AF7CD5','#F0E8D8','#EE7620','#57238A'],
    H02:['#57238A','#AF7CD5','#252221','#F0E8D8'],
    H03:['#E6651A','#F0E8D8','#EAB52D'],
    H04:['#252221','#F0E8D8','#AAA6AA'],
    H05:['#88BD43','#57238A','#252221','#88BD43','#AF7CD5'],
    H06:['#AF7CD5','#F0E8D8','#EE9163','#57238A']
  };
  const FABRIC = {
    white:'#f9f6ef', cream:'#f0e8d8', ivory:'#f6efdd', natural:'#dbcab1',
    oatmeal:'#d7c9b2', beige:'#d5bda4', sand:'#d7c5ad', tan:'#ba916d',
    taupe:'#a99684', camel:'#b68c65', brown:'#89634d', chocolate:'#674936',
    pink:'#e5a6b4', blush:'#dbadb3', rose:'#cf8e9b', dustyrose:'#c3989b',
    lightpink:'#ebbdc9', babypink:'#ebbdc9', hotpink:'#d55586', red:'#b54b4b',
    rust:'#b5674c', terracotta:'#c1866d', peach:'#e5b69b', coral:'#de9284',
    orange:'#e87832', yellow:'#e7c45e', mustard:'#c8a34a', lemon:'#efdc99',
    blue:'#a9c9dc', lightblue:'#a9c9dc', babyblue:'#b4cddc', skyblue:'#a5c8df',
    dustyblue:'#92a9bf', navy:'#24375c', navyblue:'#24375c', darkblue:'#24375c',
    green:'#75a886', sage:'#a5b4a0', sagegreen:'#a5b4a0', olive:'#8f916c',
    forest:'#4f806d', forestgreen:'#4f806d', mint:'#a8d2be', mintgreen:'#a8d2be',
    teal:'#599ba0', purple:'#9d80c1', lilac:'#c0afd0', lavender:'#bba6cb',
    grey:'#b3b4b4', gray:'#b3b4b4', lightgrey:'#c8c7c4', charcoal:'#626161',
    black:'#252221'
  };
  const HEART = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 17C-2 10 4-2 10 6c6-8 12 4 0 11Z" fill="currentColor"/></svg>';
  const VAN = '<svg viewBox="0 0 24 20" aria-hidden="true"><path d="M2 4h12v10H2zM14 8h4l4 4v2h-8M17 8v4h5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="6" cy="15" r="2" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="18" cy="15" r="2" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
  const GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h16v11H4zM3 6h18v4H3zM12 6v15M12 6c-5 0-6-1-5-3 1-2 4 0 5 3Zm0 0c5 0 6-1 5-3-1-2-4 0-5 3Z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  const states = new WeakMap(), liveStates = new Set(), catalogues = new Map(), pending = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const promptKey = 'hbr-little-extras-seen';
  let config, operation = false, lockStarted = false, sequence = 0, fitFrame = 0, activeSheet = null, promptSeen = false;
  function hasSeenPrompt() {
    try { return promptSeen || sessionStorage.getItem(promptKey)==='1'; } catch { return promptSeen; }
  }
  function rememberPrompt(seen) {
    promptSeen=seen;
    try { if(seen)sessionStorage.setItem(promptKey,'1');else sessionStorage.removeItem(promptKey); } catch { /* Storage may be unavailable. */ }
  }
  function readConfig() {
    try {
      const data = JSON.parse(document.querySelector('[data-hbr-bag-config]')?.textContent || '{}');
      return {...data, enable:!!data.enable,
        threshold:data.threshold !== null && data.threshold !== '' && Number.isFinite(Number(data.threshold)) && Number(data.threshold) >= 0 ? Number(data.threshold) : null,
        extrasTag:String(data.extrasTag || 'little extras').toLowerCase().trim(),
        tagHandle:String(data.tagHandle || 'little-extras'), collectionHandle:String(data.collectionHandle || 'all'),
        extrasLimit:Math.min(12,Math.max(4,Number(data.extrasLimit)||8))};
    } catch { return {enable:false}; }
  }
  config = readConfig();
  const currencyOf = cart => cart?.currency || config.currency || config.shopCurrency || 'GBP';
  const money = (cents, cart) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:currencyOf(cart),minimumFractionDigits:Number.isInteger(cents/100)?0:undefined}).format(cents/100);
  const shortMoney = (cents, cart) => cents > 0 && cents < 100 && currencyOf(cart) === 'GBP' ? `${cents}p` : money(cents,cart);
  function thresholdOf(cart) {
    // Shipping thresholds are commercial rules, not currency conversions.
    // Match both destination and cart currency; never borrow another market's rule.
    const country=String(config.country || '').trim().toUpperCase(),currency=String(currencyOf(cart)).toUpperCase();
    const rules=Array.isArray(config.marketThresholds)?config.marketThresholds:[{country:'GB',currency:'GBP',amount:config.threshold}];
    const rule=[...rules].reverse().find(rule=>rule && String(rule.country || '').trim().toUpperCase()===country && String(rule.currency || '').trim().toUpperCase()===currency);
    const value=rule?.amount;
    if(typeof value!=='number' && (typeof value!=='string' || !/^\d+(?:\.\d+)?$/.test(value.trim())))return null;
    const units=Number(value),cents=Math.round(units*100);
    return Number.isFinite(units) && units>=0 && Number.isSafeInteger(cents)?cents:null;
  }
  const deliveryWord = () => config.country === 'US' ? 'shipping' : 'delivery';
  const deliveryNoun = () => `free ${deliveryWord()}`;
  const freeDeliveryCopy = () => `Free ${deliveryWord()}`;
  const deliveryAtCheckout = (verb = 'confirmed') => `${config.country === 'US' ? 'Shipping' : 'Delivery'} ${verb} at checkout`;
  const discountCode = value => String(value || '').trim().toLowerCase();
  function isWelcomeDiscount(discount) {
    let code=config.welcomeCode;
    if(!code)try {code=JSON.parse(document.querySelector('[data-credit-config]')?.textContent || '{}').codes?.welcome;}catch { /* Config is optional. */ }
    code=discountCode(code || 'ROSIEWELCOME');
    return discount?.target_type !== 'shipping_line' && [discount?.code,discount?.title].some(value=>discountCode(value)===code);
  }
  function welcomeDiscount(cart) {
    // Use actual Shopify allocations, never the nominal £5 or a claimed flag.
    // Cart-level applications and line-level allocations are disjoint surfaces.
    const order=(cart.cart_level_discount_applications || []).filter(isWelcomeDiscount).reduce((sum,d)=>sum+(amount(Number(d.total_allocated_amount)) || 0),0);
    const lines=cart.items.reduce((sum,item)=>sum+(item.line_level_discount_allocations || []).filter(d=>isWelcomeDiscount(d.discount_application)).reduce((n,d)=>n+(amount(Number(d.amount)) || 0),0),0);
    return order+lines;
  }
  const deliverySpend = cart => cart.total_price+welcomeDiscount(cart);
  const isFree = cart => !!cart.items.length && thresholdOf(cart) !== null && deliverySpend(cart) >= thresholdOf(cart);
  const tagsOf = product => (Array.isArray(product?.tags) ? product.tags : String(product?.tags || '').split(',')).map(t=>String(t).toLowerCase().trim());
  const optionsOf = product => (product?.options || []).map(o=>typeof o === 'string'?{name:o}:o);
  const variantOptions = variant => variant?.options || [variant?.option1,variant?.option2,variant?.option3].filter(v=>v!=null);
  const isPersonalOption = option => ['personalisation','personalization'].includes(normalise(option.name));
  const isPlain = value => ['nonpersonalised','nonpersonalized'].includes(normalise(value));
  const needsPersonalisation = product => tagsOf(product).some(t=>['personalisation','personalization','yarn embroidery','yarn-embroidery','embroidery','machine embroidery','machine-embroidery','yarn knitting'].includes(t)) || optionsOf(product).some(isPersonalOption);
  function personalVariant(product,variant) {
    const index=optionsOf(product).findIndex(isPersonalOption);
    return needsPersonalisation(product) && !(index>=0 && isPlain(variantOptions(variant)[index]));
  }
  function eligibleVariants(product) {
    if (!product || product.available === false || product.gift_card || product.requires_selling_plan ||
      Number(product.variants_count)>250 || !tagsOf(product).includes(config.extrasTag) ||
      ['gift-box','icon-personalisation'].includes(product.handle)) return [];
    return (product.variants || []).filter(v=>v.available && amount(v.price)>0 && Number.isSafeInteger(Number(v.id)) &&
      v.requires_shipping !== false && !v.requires_selling_plan && !v.requires_components);
  }
  function quoteSafe(cart) {
    // A cart-wide percentage or automatic promotion can change on the next add.
    // Keep the actual progress, but don't promise an unconfirmed future total.
    return Number(cart.total_discount || 0)<=welcomeDiscount(cart) &&
      !(cart.cart_level_discount_applications || []).some(d=>Number(d.total_allocated_amount)>0 && !isWelcomeDiscount(d)) &&
      cart.items.every(item=>{
        const own=(item.line_level_discount_allocations || []).filter(d=>isWelcomeDiscount(d.discount_application)).reduce((sum,d)=>sum+Number(d.amount || 0),0);
        return Number(item.total_discount || 0)<=own &&
          !(item.line_level_discount_allocations || []).some(d=>Number(d.amount)>0 && !isWelcomeDiscount(d.discount_application)) &&
          (amount(item.original_line_price)===null || item.original_line_price-Number(item.final_line_price)<=own);
      });
  }
  const fingerprint = cart => JSON.stringify([currencyOf(cart),cart.total_price,cart.items.map(i=>[i.key,i.variant_id||i.id,i.quantity,i.final_line_price])]);
  const sourceKey = cart => JSON.stringify([route(''),currencyOf(cart),config.country,config.collectionHandle,config.tagHandle,config.extrasTag]);
  async function request(path, payload, preview = false, html = false) {
    const controller = new AbortController(), timer = setTimeout(()=>controller.abort(),12000);
    try {
      const url = new URL(route(path),location.origin);
      if (preview) {
        const theme = new URL(location.href).searchParams.get('preview_theme_id');
        if (theme) url.searchParams.set('preview_theme_id',theme);
      }
      const response = await fetch(url.href,{method:payload?'POST':'GET',credentials:'same-origin',cache:'no-store',signal:controller.signal,
        headers:{Accept:preview?'text/html':'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{body:JSON.stringify(payload)}:{})});
      let data;
      try { data = html ? await response.text() : await response.json(); } catch { throw new Error('Your bag could not be updated. Please try again.'); }
      if (!response.ok) throw new Error(typeof data.description === 'string'?data.description:'Your bag could not be updated. Please try again.');
      return data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('This is taking a little longer. Please check your bag before trying again.');
      throw error;
    } finally { clearTimeout(timer); }
  }
  async function readCart() {
    const cart = await request('cart.js');
    if (!Array.isArray(cart.items) || amount(cart.total_price)===null) throw new Error('Please refresh your bag to check its contents.');
    return cart;
  }
  async function loadCatalogue(cart, force = false) {
    const key = sourceKey(cart), cached = catalogues.get(key);
    if (!force && cached?.expires>Date.now()) return cached.products;
    if (pending.has(key)) return pending.get(key);
    const source = {handle:config.collectionHandle,currency:currencyOf(cart)};
    const job = (async()=>{
      let products = [], page = 1, pages = 1;
      do {
        // Filter inside the Liquid view. An unused tag in the URL can redirect
        // to the normal collection page and turn an empty list into a JSON error.
        const path = `collections/${encodeURIComponent(source.handle)}?view=hbr-little-extras&page=${page}`;
        const data = await request(path,undefined,true);
        if (!Array.isArray(data.products) || data.currency!==source.currency) throw new Error('Little extras are temporarily unavailable.');
        products.push(...data.products);
        pages = Math.min(100,Math.max(1,Number(data.pages)||1));
        page++;
      } while (page<=pages && products.length<72);
      // Recheck tags and eligibility before offering any returned product.
      const seen = new Set();
      products = products.filter(p=>p.handle && !seen.has(String(p.id)) && seen.add(String(p.id)) && eligibleVariants(p).length);
      catalogues.set(key,{products,expires:Date.now()+60000});
      return products;
    })();
    pending.set(key,job);
    try { return await job; } finally { if (pending.get(key)===job) pending.delete(key); }
  }
  function availableChoices(state) {
    const products=state.products.filter(p=>eligibleVariants(p).length);
    const gap=thresholdOf(state.cart)===null?null:thresholdOf(state.cart)-deliverySpend(state.cart);
    if(state.dialog.open && state.browseOrder) {
      const order=new Map(state.browseOrder.map((id,index)=>[id,index]));
      products.sort((a,b)=>(order.get(String(a.id))??Infinity)-(order.get(String(b.id))??Infinity));
    } else if(gap>0 && quoteSafe(state.cart)) {
      const best=product=>Math.min(...eligibleVariants(product).filter(v=>v.price>=gap).map(v=>v.price));
      products.sort((a,b)=>{
        const x=best(a),y=best(b);
        return Number(Number.isFinite(y))-Number(Number.isFinite(x)) || (Number.isFinite(x)&&Number.isFinite(y)?x-y:0);
      });
    }
    const choices=products.slice(0,config.extrasLimit);
    if(state.dialog.open && !state.browseOrder && choices.length)state.browseOrder=choices.map(product=>String(product.id));
    return choices;
  }
  function addExtra(state,product) {
    if(operation || state.uncertain || state.checking || !state.dialog.open)return;
    const variant=chosenVariant(state,product);if(!variant)return;
    const key=String(product.id);
    const properties=personalProperties(state,product,variant);
    if(properties===null)return;
    // This is the one requested add, never a collection of unconfirmed selections.
    state.selections.clear();
    state.selections.set(key,{productId:key,handle:product.handle,title:product.title,id:Number(variant.id),price:variant.price,quantity:1,properties});
    state.addingProductId=key;
    void addSelected(state);
  }
  function updateScrollHint(state) {
    if(!state.scrollHint)return;
    const scroller=state.openId?state.sheetBody:state.rail.parentElement;
    const more=state.dialog.open && !state.extras.hidden && scroller.scrollHeight-scroller.clientHeight-scroller.scrollTop>8;
    state.scrollHint.firstChild.textContent=state.openId?'Scroll for options & details ':'Scroll for more extras ';
    state.scrollHint.hidden=!more;
  }
  function chosenOptions(state, product) {
    const id = String(product.id);
    if (!state.choices.has(id)) {
      const variants=eligibleVariants(product),threshold=thresholdOf(state.cart);
      const qualifying=threshold!==null && quoteSafe(state.cart) && !isFree(state.cart)?variants.filter(v=>deliverySpend(state.cart)+v.price>=threshold).sort((a,b)=>a.price-b.price)[0]:null;
      state.choices.set(id,[...variantOptions(qualifying||variants[0])]);
    }
    return state.choices.get(id);
  }
  function chosenVariant(state, product) {
    const selected = chosenOptions(state,product);
    return eligibleVariants(product).find(v=>variantOptions(v).every((value,i)=>value===selected[i]));
  }
  const photoOf = (product,variant) => variant?.featured_image || variant?.image || product.featured_image || product.images?.[0];
  const colourOf = value => FABRIC[normalise(value)] || Object.entries(FABRIC).sort((a,b)=>b[0].length-a[0].length).find(([name])=>normalise(value).includes(name))?.[1] || '#ded2be';
  function previewStyle(properties) {
    const explicit = properties['Personalisation method'];
    const yarn = explicit ? /yarn/i.test(explicit) : !!properties['Yarn colour'] || !properties['Thread colour'] && !properties['Embroidery font'];
    const colour = properties[yarn?'Yarn colour':'Thread colour'];
    const entry = (yarn?YARN:THREAD).find(([name])=>normalise(name)===normalise(colour) || yarn && normalise(name.replace(/^\d+\s*·\s*/,''))===normalise(colour));
    const schemeCode = String(colour||'').match(/\b[NH]0[1-6]\b/i)?.[0].toUpperCase();
    // Legacy yarn choices use "Thread colour"; explicit machine embroidery never uses a yarn palette.
    const scheme = (yarn || !explicit && schemeCode?.startsWith('H')) && SCHEMES[schemeCode];
    const font = /^F(?:10|[1-9])$/i.test(properties['Embroidery font']||'')?properties['Embroidery font'].toUpperCase():'F1';
    return {yarn,palette:scheme,hex:entry?.[1]||({Berry:'#8C3B4A',Sage:'#5F7A5E',Ink:'#332B24'}[colour])||(yarn?YARN[0][1]:THREAD[0][1]),family:yarn?'Little Keepsake Script':`HBR Machine ${font}`,weight:!yarn&&['F4','F10'].includes(font)?700:400};
  }
  function nameChip(item) {
    const name = String(item.properties?.['Name or text']||'');
    if (!config.showPreviews || !name.trim()) return null;
    const style = previewStyle(item.properties);let index=0;
    const letters = style.palette?Array.from(name).map(c=>/\s/.test(c)?escape(c):`<span style="color:${style.palette[index++%style.palette.length]}">${escape(c)}</span>`).join(''):escape(name);
    const chip = document.createElement('div');chip.className='hbr-bag__name-chip';chip.dataset.hbrBagPreview=item.key;
    chip.setAttribute('role','img');chip.setAttribute('aria-label',`Live preview: ${name}`);
    chip.innerHTML=`<span class="hbr-bag__name-stage" aria-hidden="true"><span class="hbr-bag__stitch" style="font-family:'${style.family}',cursive;font-weight:${style.weight};color:${style.hex}">${letters}</span></span>`;
    return chip;
  }
  function fitPreviews() {
    cancelAnimationFrame(fitFrame);
    fitFrame=requestAnimationFrame(()=>{
      for (const state of liveStates) {
        if (!state.drawer.isConnected) {state.resize?.disconnect();state.observer?.disconnect();closeSheet(state,false);state.dialog.remove();liveStates.delete(state);continue;}
        state.drawer.querySelectorAll('.hbr-bag__stitch').forEach(ink=>{
          ink.style.fontSize='40px';
          const width=ink.parentElement.clientWidth;
          if(width && ink.scrollWidth>width)ink.style.fontSize=`${Math.max(1,40*(width-2)/ink.scrollWidth)}px`;
        });
        updateScrollHint(state);
      }
    });
  }
  function restoreLines(state) {
    for (const old of state.decorated) {
      if (!old.main.isConnected) continue;
      old.bottom?.replaceChildren(...old.bottomChildren);
      old.main.replaceChildren(...old.children);
      if (old.variant) {old.variant.textContent=old.variantText;old.variant.hidden=old.variantHidden;}
      if (old.properties) {old.properties.hidden=old.propertiesHidden;old.rows.forEach(([li,hidden])=>{li.hidden=hidden;});}
      old.article.classList.remove('hbr-bag__compact-line');delete old.article.dataset.hbrBagLine;
    }
    state.decorated=[];
  }
  function decorateLines(state) {
    restoreLines(state);
    if (!config.enable) return;
    const lines=new Map(state.cart.items.map(item=>[String(item.key),item]));
    state.items.querySelectorAll('[data-hbr-price-key]').forEach(price=>{
      const item=lines.get(price.dataset.hbrPriceKey),article=price.closest('.hbr-cart-drawer__item'),main=article?.querySelector('.hbr-cart-drawer__item-main');
      if(!item||!main)return;
      const title=main.querySelector('.hbr-cart-drawer__item-title'),bottom=main.querySelector('.hbr-cart-drawer__item-bottom'),qty=main.querySelector('.hbr-cart-drawer__qty'),remove=main.querySelector('[data-hbr-cart-remove]'),properties=main.querySelector('.hbr-cart-drawer__properties');
      if(!title||!bottom||!qty||!remove)return;
      let variant=main.querySelector('.hbr-cart-drawer__variant');
      const saved={article,main,bottom,bottomChildren:[...bottom.childNodes],children:[...main.childNodes],variant,variantText:variant?.textContent,variantHidden:variant?.hidden,properties,propertiesHidden:properties?.hidden,rows:properties?[...properties.children].map(li=>[li,li.hidden]):[]};
      state.decorated.push(saved);
      const heading=document.createElement('div');heading.className='hbr-bag__line-heading';heading.append(title,price);
      const opts=(item.options_with_values||[]).filter(o=>!isPersonalOption(o)).map(o=>o.value).filter(v=>v && normalise(v)!=='defaulttitle');
      let meta=opts.length?opts.join(' · '):String(item.variant_title||'').split(' / ').filter(v=>!['defaulttitle','personalised','personalized','nonpersonalised','nonpersonalized'].includes(normalise(v))).join(' · ');
      const props=item.properties||{},stitch=props['Yarn colour']||props['Thread colour'];
      if(stitch)meta=[meta,`${String(stitch).replace(/^\d+\s*·\s*/,'')} ${props['Yarn colour']?'yarn':'thread'}`,props['Embroidery font']||''].filter(Boolean).join(' · ');
      if(meta&&!variant){variant=document.createElement('p');variant.className='hbr-cart-drawer__variant';}
      if(variant){variant.textContent=meta;variant.hidden=!meta;}
      const chip=nameChip(item),hiddenKeys=new Set();
      if(chip)hiddenKeys.add('Name or text');
      if(stitch){hiddenKeys.add(props['Yarn colour']?'Yarn colour':'Thread colour');if(props['Embroidery font'])hiddenKeys.add('Embroidery font');}
      if(stitch||chip)hiddenKeys.add('Personalisation method');
      if(properties){
        [...properties.children].forEach(li=>{li.hidden=hiddenKeys.has((li.querySelector('strong')?.textContent||'').replace(/:\s*$/,'').trim());});
        properties.hidden=[...properties.children].every(li=>li.hidden);
      }
      const row=document.createElement('div');row.className='hbr-bag__line-bottom';
      const actions=document.createElement('div');actions.className='hbr-bag__line-actions';actions.append(qty,remove);
      if(chip)row.append(chip);row.append(actions);
      main.replaceChildren(heading,...(variant?[variant]:[]),...(properties?[properties]:[]),row);
      article.classList.add('hbr-bag__compact-line');article.dataset.hbrBagLine=item.key;
    });
    fitPreviews();
  }
  function renderProgress(state) {
    const cart=state.cart,threshold=thresholdOf(cart),free=isFree(cart);
    const show=config.enable && cart.items.length>0;
    state.progress.hidden=!show;
    state.drawer.toggleAttribute('data-hbr-bag-hide-credit',!!(show && config.hideCredit));
    if(!show)return;
    const ratio=threshold===null?0:threshold===0?100:Math.min(100,100*deliverySpend(cart)/threshold);
    const title=state.progress.querySelector('.hbr-bag__delivery-copy');
    title.textContent=threshold===null?deliveryAtCheckout('calculated'):free?`${freeDeliveryCopy()}, with love`:`${money(Math.max(0,threshold-deliverySpend(cart)),cart)} to ${deliveryNoun()}`;
    state.progress.querySelector('.hbr-bag__almost').hidden=free || threshold===null;
    state.progress.classList.toggle('is-free',free);
    state.progress.classList.toggle('is-unknown',threshold===null);
    state.progress.querySelector('.hbr-bag__goal').innerHTML=free?HEART:GIFT;
    const track=state.progress.querySelector('[role="progressbar"]');
    track.setAttribute('aria-valuenow',String(Math.round(ratio)));
    track.setAttribute('aria-valuetext',title.textContent);
    const wasFree=state.lastFree,firstPaint=state.lastTotal===null;
    state.lastFree=free;
    if(free && !wasFree && state.lastTotal!==null && !reduced.matches) {
      state.progress.classList.remove('is-celebrating');
      requestAnimationFrame(()=>state.progress.classList.add('is-celebrating'));
    } else if(!free)state.progress.classList.remove('is-celebrating');
    state.lastTotal=cart.total_price;
    cancelAnimationFrame(state.progressFrame);
    const fill=()=>state.progress.style.setProperty('--hbr-bag-progress',`${ratio}%`);
    state.progressFrame=requestAnimationFrame(()=>{
      if(firstPaint && !reduced.matches)state.progressFrame=requestAnimationFrame(fill);
      else fill();
    });
    renderForecast(state);
  }
  function renderForecast(state) {
    const threshold=thresholdOf(state.cart);
    const product=availableChoices(state).find(p=>String(p.id)===(state.openId || state.hoverId));
    const variant=product && chosenVariant(state,product);
    const possible=variant && threshold>0 && !isFree(state.cart) && quoteSafe(state.cart);
    const start=threshold>0?Math.min(100,100*deliverySpend(state.cart)/threshold):0;
    const end=possible?Math.min(100,100*(deliverySpend(state.cart)+variant.price)/threshold):start;
    state.progress.style.setProperty('--hbr-bag-forecast-start',`${start}%`);
    state.progress.style.setProperty('--hbr-bag-forecast-width',`${Math.max(0,end-start)}%`);
    state.progress.classList.toggle('has-forecast',!!possible);
  }
  function variantDeliveryCopy(state,variant) {
    const threshold=thresholdOf(state.cart);
    if(isFree(state.cart))return 'This little extra ships free too';
    if(!variant)return 'Choose an available size and colour';
    if(threshold===null || !quoteSafe(state.cart))return deliveryAtCheckout();
    const gap=threshold-deliverySpend(state.cart)-variant.price;
    if(gap<=0)return `Your ${deliveryWord()} will be free`;
    return `${shortMoney(gap,state.cart)} still to ${deliveryNoun()} after adding`;
  }
  function productImage(product,variant,eager=false) {
    const src=safeURL(photoOf(product,variant));
    return src?`<img src="${src}" alt="" loading="${eager?'eager':'lazy'}" decoding="async" width="720" height="720">`:`<span class="hbr-bag__photo-fallback" aria-hidden="true">${GIFT}</span>`;
  }
  function unlocksDelivery(state,variant) {
    const threshold=thresholdOf(state.cart);
    return !!variant && threshold!==null && quoteSafe(state.cart) && !isFree(state.cart) && deliverySpend(state.cart)+variant.price>=threshold;
  }
  function cardDeliveryCopy(state,variant) {
    if(isFree(state.cart))return 'Ships free';
    if(unlocksDelivery(state,variant))return `${freeDeliveryCopy()} with your bag`;
    const threshold=thresholdOf(state.cart);
    if(!variant || threshold===null || !quoteSafe(state.cart))return deliveryAtCheckout();
    return `${shortMoney(Math.max(0,threshold-deliverySpend(state.cart)-variant.price),state.cart)} to go after adding`;
  }
  const rawPhoto = value => typeof value==='string'?value:value?.src || value?.url || '';
  const photoKey = value => {try{return new URL(rawPhoto(value),location.origin).pathname;}catch{return '';}};
  function photosOf(product) {
    const seen=new Set();
    return [product.featured_image,...(product.images || []),...(product.variants || []).map(v=>v.featured_image || v.image)].filter(value=>{
      const key=photoKey(value);return rawPhoto(value) && safeURL(value) && !seen.has(key) && seen.add(key);
    }).map(value=>({src:rawPhoto(value),alt:value?.alt || product.title}));
  }
  const CHEVRON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function galleryHTML(state,product) {
    const photos=photosOf(product),id=String(product.id),index=Math.min(state.photos.get(id)||0,Math.max(0,photos.length-1));
    state.photos.set(id,index);
    if(!photos.length)return `<div class="hbr-bag__panel-photo">${productImage(product,null,true)}</div>`;
    return `<div class="hbr-bag__gallery" data-gallery-product="${escape(id)}" role="region" aria-label="Product photos"><div class="hbr-bag__photo-track" tabindex="0" aria-label="Swipe or use the arrow keys to browse product photos">${photos.map((photo,i)=>`<div class="hbr-bag__photo-slide" role="group" aria-label="Photo ${i+1} of ${photos.length}"><img src="${safeURL(photo.src)}" alt="${escape(photo.alt)}" loading="${i===index?'eager':'lazy'}" decoding="async" width="1200" height="1600"></div>`).join('')}</div><div class="hbr-bag__photo-nav"><button type="button" data-hbr-bag-action="photo-prev" data-product="${escape(id)}" aria-label="Previous product photo" ${photos.length<2?'disabled':''}>${CHEVRON}</button><span class="hbr-bag__photo-count" aria-live="polite">${index+1} / ${photos.length} photos</span><button type="button" data-hbr-bag-action="photo-next" data-product="${escape(id)}" aria-label="Next product photo" ${photos.length<2?'disabled':''}>${CHEVRON}</button></div><div class="hbr-bag__photo-thumbs" aria-label="Choose a product photo">${photos.map((photo,i)=>`<button type="button" data-hbr-bag-action="photo" data-product="${escape(id)}" data-photo="${i}" aria-label="View photo ${i+1}" aria-pressed="${i===index}"><img src="${safeURL(photo.src)}" alt="" loading="lazy" width="100" height="100"></button>`).join('')}</div><a class="hbr-bag__full-photo" href="${safeURL(photos[index].src)}" target="_blank" rel="noopener">View full-size photo</a></div>`;
  }
  function paintPhotoPosition(state,product,index) {
    const photos=photosOf(product),gallery=state.panel.querySelector('.hbr-bag__gallery');
    if(!gallery || !photos.length)return;
    index=Math.max(0,Math.min(index,photos.length-1));state.photos.set(String(product.id),index);
    gallery.querySelector('.hbr-bag__photo-count').textContent=`${index+1} / ${photos.length} photos`;
    gallery.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.photo)===index)));
    gallery.querySelector('.hbr-bag__full-photo').href=rawPhoto(photos[index]);
  }
  function movePhoto(state,product,index,animate=true) {
    const photos=photosOf(product),track=state.panel.querySelector('.hbr-bag__photo-track');if(!track || !photos.length)return;
    index=(index+photos.length)%photos.length;paintPhotoPosition(state,product,index);
    track.scrollTo({left:track.clientWidth*index,behavior:animate&&!reduced.matches?'smooth':'instant'});
  }
  function bindGallery(state,product) {
    const track=state.panel.querySelector('.hbr-bag__photo-track');if(!track)return;
    track.addEventListener('scroll',()=>{if(track.clientWidth)paintPhotoPosition(state,product,Math.round(track.scrollLeft/track.clientWidth));},{passive:true});
    track.addEventListener('keydown',event=>{
      if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
      event.preventDefault();movePhoto(state,product,(state.photos.get(String(product.id))||0)+(event.key==='ArrowRight'?1:-1));
    });
    movePhoto(state,product,state.photos.get(String(product.id))||0,false);
  }
  function productLink(product,variant) {
    return route(`products/${encodeURIComponent(product.handle)}`)+(variant?`?variant=${Number(variant.id)}`:'');
  }
  async function loadPersonalForm(state,product,retry=false) {
    const id=String(product.id);
    if(!needsPersonalisation(product) || state.personalForms.has(id)&&!retry)return;
    const model={status:'loading',fields:[],values:{}};state.personalForms.set(id,model);
    try {
      // Read the real product form so colours, fonts and length limits match the PDP.
      // Only copy known field data. Never inject or execute fetched markup/scripts.
      const html=await request(`products/${encodeURIComponent(product.handle)}`,undefined,true,true);
      const doc=new DOMParser().parseFromString(html,'text/html');
      const panel=doc.querySelector('[data-hbr-personalisation-panel]');
      if(!panel || tagsOf(product).some(tag=>['icon-choice','halloween-icon-choice'].includes(tag)))model.status='full-page';
      else {
        const fields=new Map(),allowed=new Set(['Name or text','Personalisation method','Yarn colour','Thread colour','Embroidery font']);
        let unsupported=false;
        for(const input of panel.querySelectorAll('[name^="properties["]')) {
          const name=input.name.match(/^properties\[(.+)\]$/)?.[1];
          if(!allowed.has(name) || !['text','hidden','radio'].includes(input.type)){unsupported=true;break;}
          if(!fields.has(name))fields.set(name,{name,type:input.type,values:[],initial:'',maxLength:input.maxLength>0?input.maxLength:40});
          const field=fields.get(name);
          if(input.type==='radio') {field.values.push(input.value);if(input.checked)field.initial=input.value;}
          else field.initial=input.value || '';
        }
        if(unsupported || !fields.has('Name or text'))model.status='full-page';
        else {
          model.fields=[...fields.values()];
          model.fields.forEach(field=>{model.values[field.name]=field.initial || (field.type==='radio'?field.values[0]:'');});
          model.status='ready';
        }
      }
    } catch {model.status='error';}
    if(state.personalForms.get(id)!==model)return;
    if(state.openId===id && state.dialog.open)renderExtras(state);
  }
  function personalHTML(state,product,variant) {
    if(!personalVariant(product,variant))return '';
    const id=String(product.id),model=state.personalForms.get(id);
    if(!model || model.status==='loading')return '<p class="hbr-bag__personal-note" role="status">Loading personalisation choices…</p>';
    if(model.status!=='ready')return `<div class="hbr-bag__personal-note"><p>${model.status==='error'?'Personalisation could not load.':'Choose all the details, including any icons or uploads, on the product page.'}</p>${model.status==='error'?`<button type="button" data-hbr-bag-action="personal-retry" data-product="${escape(id)}">Try again</button>`:''}<a class="hbr-bag__add" href="${escape(productLink(product,variant))}">Personalise on product page</a></div>`;
    return `<div class="hbr-bag__personal"><h5>Make it theirs</h5>${model.fields.filter(field=>field.type!=='hidden').map((field,index)=>{
      const inputId=`${state.id}-personal-${index}`;
      return `<label for="${inputId}">${escape(field.name)}</label>${field.type==='text'?`<input id="${inputId}" type="text" data-personal-property="${escape(field.name)}" data-focus="personal-${index}" maxlength="${field.maxLength}" placeholder="Their name here" value="${escape(model.values[field.name])}" autocomplete="off" required>`:`<select id="${inputId}" data-personal-property="${escape(field.name)}" data-focus="personal-${index}">${field.values.map(value=>`<option value="${escape(value)}" ${model.values[field.name]===value?'selected':''}>${escape(value)}</option>`).join('')}</select>`}`;
    }).join('')}<p class="hbr-bag__personal-preview" aria-label="Personalisation preview"></p></div>`;
  }
  function paintPersonalPreview(state,product) {
    const node=state.panel.querySelector('.hbr-bag__personal-preview'),model=state.personalForms.get(String(product.id));if(!node || model?.status!=='ready')return;
    const style=previewStyle(model.values),name=model.values['Name or text'] || 'Their name here';let index=0;
    node.style.fontFamily=`'${style.family}',cursive`;node.style.fontWeight=style.weight;node.style.color=style.hex;
    node.replaceChildren(...Array.from(name).map(letter=>{const span=document.createElement('span');span.textContent=letter;if(style.palette && !/\s/.test(letter))span.style.color=style.palette[index++%style.palette.length];return span;}));
  }
  function personalProperties(state,product,variant) {
    if(!personalVariant(product,variant))return {};
    const model=state.personalForms.get(String(product.id));
    if(model?.status!=='ready')return null;
    const properties={};
    for(const field of model.fields) {
      const value=String(model.values[field.name] || '').trim();
      if(field.name==='Name or text' && (!value || value.length>field.maxLength)) {
        state.error=`Please enter a name or text (up to ${field.maxLength} characters).`;paintStatus(state);
        state.panel.querySelector('[data-personal-property="Name or text"]')?.focus();return null;
      }
      if(field.type==='radio' && !field.values.includes(value))return null;
      properties[field.name]=value;
    }
    return properties;
  }
  function detailsHTML(product,variant) {
    const description=product.description_text || (product.description?new DOMParser().parseFromString(product.description,'text/html').body.textContent:'');
    return `<div class="hbr-bag__product-details">${description?`<details><summary>About this little extra</summary><p>${escape(description)}</p></details>`:''}${product.sizing_text?`<details><summary>Sizing &amp; care</summary><p>${escape(product.sizing_text)}</p></details>`:''}<a href="${escape(productLink(product,variant))}">View full product details</a></div>`;
  }
  function renderPanel(state,product) {
    if(!product){state.panel.hidden=true;state.panel.replaceChildren();return;}
    const variants=eligibleVariants(product),selected=chosenOptions(state,product),variant=chosenVariant(state,product);
    const fields=optionsOf(product).map((option,index)=>{
      const values=[...new Set((product.variants||[]).map(v=>variantOptions(v)[index]).filter(v=>v!=null))];
      if(values.length<=1 && (normalise(option.name)==='title' || isPersonalOption(option)))return '';
      const colour=/^(colou?r)$/i.test(option.name);
      const buttons=values.map(value=>{
        const active=selected[index]===value;
        const available=variants.some(v=>variantOptions(v)[index]===value);
        const native=(option.values||[]).find(v=>(typeof v==='string'?v:v.name)===value)?.swatch;
        const hex=typeof native==='string' && /^#[a-f0-9]{3,8}$/i.test(native)?native:colourOf(value);
        return `<button type="button" class="${colour?'hbr-bag__swatch':'hbr-bag__option'}${active?' is-selected':''}" data-hbr-bag-action="option" data-product="${escape(product.id)}" data-index="${index}" data-value="${escape(value)}" data-focus="option-${index}-${escape(value)}" aria-pressed="${active}" aria-label="${escape(`${option.name}: ${value}${available?'':' (sold out)'}`)}" title="${escape(value)}" ${available?'':'disabled'}>${colour?`<span style="--hbr-bag-swatch:${hex}" aria-hidden="true"></span><span class="hbr-bag__sr-only">${escape(value)}</span>`:escape(value)}</button>`;
      }).join('');
      return `<fieldset class="hbr-bag__options"><legend>${escape(option.name)}: <span>${escape(selected[index]||'')}</span></legend><div>${buttons}</div></fieldset>`;
    }).join('');
    const model=state.personalForms.get(String(product.id)),personal=personalVariant(product,variant);
    const canAdd=variant && (!personal || model?.status==='ready');
    const fullPage=personal && ['full-page','error'].includes(model?.status);
    state.panel.hidden=false;
    state.panel.innerHTML=`<div class="hbr-bag__panel-heading"><h4 id="${state.id}-panel-title">${escape(product.title)}</h4><button type="button" class="hbr-bag__panel-close" data-hbr-bag-action="close" data-focus="close" aria-label="Back to little extras">Back</button></div>${galleryHTML(state,product)}<div class="hbr-bag__panel-controls">${fields}${personalHTML(state,product,variant)}<p class="hbr-bag__panel-delivery${unlocksDelivery(state,variant)?' will-unlock':''}">${VAN}<span>${escape(variantDeliveryCopy(state,variant))}</span></p>${fullPage?'':`<button type="button" class="hbr-bag__add" data-hbr-bag-action="add" data-product="${escape(product.id)}" data-focus="add" ${canAdd?'':'disabled'}>${!variant?'This combination is sold out':!canAdd?'Loading personalisation…':state.addingProductId===String(product.id)?'Adding…':`Add to bag · ${escape(money(variant.price,state.cart))}`}</button>`}${detailsHTML(product,variant)}</div>`;
    state.panel.setAttribute('aria-labelledby',`${state.id}-panel-title`);
    bindGallery(state,product);paintPersonalPreview(state,product);
  }
  function paintStatus(state) {
    state.status.hidden=!state.error && !state.notice;
    state.status.classList.toggle('is-error',!!state.error);
    state.status.replaceChildren(document.createTextNode(state.error || state.notice));
    if(state.uncertain || state.catalogueFailed) {
      const retry=document.createElement('button');retry.type='button';retry.className='hbr-bag__retry';
      retry.dataset.hbrBagAction=state.uncertain?'refresh':'reload';
      retry.textContent=state.uncertain?'Refresh bag':'Try again';
      retry.disabled=operation;state.status.append(' ',retry);
    }
  }
  function renderExtras(state) {
    const products=availableChoices(state),active=document.activeElement;
    const focus=state.extras.contains(active)?active.dataset.focus:null;
    const scroller=state.rail.parentElement;
    if(state.extras.dataset.mode!=='options')state.browseTop=scroller.scrollTop;
    const top=state.browseTop;
    state.extras.hidden=!config.enable || !config.showExtras || !state.cart.items.length || !products.length;
    state.browseButton.hidden=state.extras.hidden || state.catalogueFailed || typeof state.dialog.showModal!=='function';
    if(state.extras.hidden){state.openId='';state.hoverId='';renderForecast(state);paintStatus(state);renderSheet(state);return;}
    if(!products.some(p=>String(p.id)===state.openId))state.openId='';
    state.extras.dataset.mode=state.openId?'options':'browse';
    state.rail.innerHTML=products.map((product,index)=>{
      const id=String(product.id),variants=eligibleVariants(product),variant=chosenVariant(state,product);
      const price=variant?.price ?? Math.min(...variants.map(v=>v.price));
      const multiple=variants.length>1,quantity=variants.reduce((total,v)=>total+extraCount(state.cart,Number(v.id)),0);
      const detail=quantity && variant?variantOptions(variant).filter(value=>value!=='Default Title').join(' · '):'';
      const adding=state.addingProductId===id;
      const configure=multiple || needsPersonalisation(product),label=needsPersonalisation(product)?'Personalise':multiple?'Choose options':quantity?'Add another':'Add to bag';
      const controls=`<button type="button" class="hbr-bag__choose" data-hbr-bag-action="choose" data-product="${escape(id)}" data-focus="choose-${escape(id)}" aria-label="${escape(`${configure?'Choose options for':'Add to bag:'} ${product.title}`)}">${adding?'Adding…':label} <span aria-hidden="true">+</span></button>`;
      return `<article class="hbr-bag__extra${quantity?' is-in-bag':''}" data-hbr-bag-product="${escape(id)}"><button type="button" class="hbr-bag__extra-photo" data-hbr-bag-action="details" data-product="${escape(id)}" data-focus="photo-${escape(id)}" aria-label="${escape(`View ${product.title}`)}" aria-expanded="${state.openId===id}" aria-controls="${state.id}-panel">${productImage(product,quantity?variant:null,state.dialog.open && index<2)}${quantity?`<span class="hbr-bag__in-bag">${quantity} in bag</span>`:''}</button><div class="hbr-bag__extra-heading"><h4 title="${escape(product.title)}">${escape(product.title)}</h4><div class="hbr-bag__extra-meta"><span class="hbr-bag__extra-price">${variant?'':'From '}${escape(money(price,state.cart))}</span>${detail?`<span class="hbr-bag__extra-option" title="${escape(detail)}">${escape(detail)}</span>`:''}</div></div>${controls}</article>`;
    }).join('');
    scroller.scrollTop=top;
    renderPanel(state,products.find(p=>String(p.id)===state.openId));
    syncLocks(state);
    if(state.uncertain || state.checking)state.extras.querySelectorAll('button').forEach(button=>{button.disabled=true;});
    if(focus){const next=[...state.extras.querySelectorAll('[data-focus]')].find(n=>n.dataset.focus===focus);if(next&&!next.disabled)next.focus({preventScroll:true});}
    requestAnimationFrame(()=>updateScrollHint(state));renderForecast(state);paintStatus(state);renderSheet(state);
  }
  function setHover(state,id) {
    if(state.hoverId===id)return;
    state.hoverId=id;renderForecast(state);
  }
  function bindExtras(state) {
    state.extras.addEventListener('click',event=>{
      const button=event.target.closest('[data-hbr-bag-action]');
      if(!button || button.disabled || operation || state.checking)return;
      const action=button.dataset.hbrBagAction;
      const product=availableChoices(state).find(p=>String(p.id)===button.dataset.product);
      if(action==='close') {
        const id=state.openId;state.openId='';state.hoverId='';renderExtras(state);
        [...state.rail.querySelectorAll('[data-product]')].find(n=>n.dataset.product===id)?.focus({preventScroll:true});return;
      }
      if(!product)return;
      if(action==='choose' || action==='details') {
        if(action==='choose' && eligibleVariants(product).length===1 && !needsPersonalisation(product)){addExtra(state,product);return;}
        state.openId=String(product.id);state.photos.set(String(product.id),0);state.error='';state.notice='';void loadPersonalForm(state,product);renderExtras(state);
        requestAnimationFrame(()=>{
          state.panel.querySelector('.hbr-bag__photo-track,.hbr-bag__options button:not([disabled]),.hbr-bag__add:not([disabled])')?.focus({preventScroll:true});
          state.sheetBody.scrollTo({top:0,behavior:reduced.matches?'auto':'smooth'});
        });
      } else if(action==='option') {
        chosenOptions(state,product)[Number(button.dataset.index)]=button.dataset.value;
        const variant=chosenVariant(state,product),photo=photoKey(variant?.featured_image || variant?.image);
        const index=photo?photosOf(product).findIndex(p=>photoKey(p)===photo):-1;
        if(index>=0)state.photos.set(String(product.id),index);
        state.error='';state.notice='';renderExtras(state);
      } else if(action==='photo' || action==='photo-prev' || action==='photo-next') {
        movePhoto(state,product,action==='photo'?Number(button.dataset.photo):(state.photos.get(String(product.id))||0)+(action==='photo-next'?1:-1));
      } else if(action==='personal-retry') {
        void loadPersonalForm(state,product,true);renderExtras(state);
      } else if(action==='add') {
        addExtra(state,product);
      }
    });
    const editPersonal=event=>{
      const input=event.target.closest('[data-personal-property]');if(!input || operation)return;
      const product=state.products.find(p=>String(p.id)===state.openId),model=state.personalForms.get(state.openId);
      if(!product || model?.status!=='ready')return;
      model.values[input.dataset.personalProperty]=input.value;state.error='';paintStatus(state);paintPersonalPreview(state,product);
    };
    state.extras.addEventListener('input',editPersonal);state.extras.addEventListener('change',editPersonal);
    state.rail.addEventListener('pointerover',event=>setHover(state,event.target.closest('[data-hbr-bag-product]')?.dataset.hbrBagProduct||''));
    state.rail.addEventListener('pointerleave',()=>setHover(state,''));
    state.extras.addEventListener('focusin',event=>setHover(state,event.target.closest('[data-hbr-bag-product]')?.dataset.hbrBagProduct||''));
    state.extras.addEventListener('focusout',event=>{if(!state.extras.contains(event.relatedTarget))setHover(state,'');});
    state.status.addEventListener('click',async event=>{
      const action=event.target.closest('[data-hbr-bag-action]')?.dataset.hbrBagAction;
      if(operation)return;
      if(action==='reload'){state.error='';state.catalogueFailed=false;await ensureCatalogue(state,true);}
      if(action==='refresh') {
        operation=true;for(const s of liveStates)syncLocks(s);
        try {const cart=await readCart();state.uncertain=false;state.error='';state.notice='Your bag is up to date.';if(state.pendingBatch)reconcileBatch(state,cart);else publish(cart);}
        catch {state.error='We could not refresh your bag. Please reload the page before adding again.';}
        finally {operation=false;for(const s of liveStates){syncLocks(s);renderExtras(s);}}
      }
    });
  }
  function bagBusy(state) {
    return operation || !!window.HbrGiftBox?.busy || state.items.getAttribute('aria-busy')==='true';
  }
  function undoButton(state) {
    const confirmation=state.confirmation;
    if(!confirmation || confirmation.snapshot!==fingerprint(state.cart))return null;
    const line=state.cart.items.find(item=>item.key===confirmation.key);
    if(!line || line.quantity!==1 || line.properties?._hbr_little_extra!=='1')return null;
    return [...state.items.querySelectorAll('[data-hbr-cart-remove]')].find(button=>button.dataset.hbrCartRemove===line.key);
  }
  function paintBagNotice(state) {
    const confirmation=state.confirmation;
    if(confirmation && !state.cart.items.some(item=>(confirmation.keys||[confirmation.key]).includes(item.key)))state.confirmation=null;
    state.bagNotice.hidden=!config.enable || !state.confirmation;
    state.bagNotice.replaceChildren();
    if(state.bagNotice.hidden)return;
    const text=document.createElement('span');text.textContent=confirmation.text;state.bagNotice.append(text);
    if(undoButton(state)) {
      const undo=document.createElement('button');undo.type='button';undo.dataset.hbrExtraUndo='';undo.textContent='Undo';
      undo.disabled=bagBusy(state);state.bagNotice.append(undo);
    }
  }
  function continueShopping(state) {
    if(bagBusy(state))return;
    state.confirmation=null;paintBagNotice(state);closeSheet(state,false);
    if(window.HbrSharedBag?.close)window.HbrSharedBag.close();
    else state.drawer.querySelector('[data-hbr-cart-close]')?.click();
  }
  function renderSheetProgress(state) {
    const progress=state.sheetProgress,threshold=thresholdOf(state.cart),free=isFree(state.cart);
    progress.hidden=!config.enable || !state.dialog.open || state.checking || !state.cart.items.length;
    if(progress.hidden)return;
    const ratio=threshold===null?0:threshold===0?100:Math.min(100,100*deliverySpend(state.cart)/threshold);
    const track=progress.querySelector('[role="progressbar"]');
    track.setAttribute('aria-valuenow',String(Math.round(ratio)));
    track.setAttribute('aria-valuetext',state.sheetShipping.textContent);
    progress.classList.toggle('is-free',free);
    progress.classList.toggle('is-unknown',threshold===null);
    progress.querySelector('.hbr-bag__almost').hidden=free || threshold===null;
    progress.querySelector('.hbr-bag__goal').innerHTML=free?HEART:GIFT;
    progress.style.setProperty('--hbr-bag-progress',`${ratio}%`);
  }
  function renderSheet(state) {
    if(!state.cart)return;
    state.dialog.dataset.view=state.openId?'product':'browse';
    const free=isFree(state.cart),threshold=thresholdOf(state.cart);
    const gap=threshold===null?null:Math.max(0,threshold-deliverySpend(state.cart));
    state.sheetTitle.textContent='little extras, lots of love';
    state.sheetCopy.textContent='Add a little extra, or continue to checkout.';
    const shipping=free?`${freeDeliveryCopy()}, with love`:
      gap===null?deliveryAtCheckout():`${money(gap,state.cart)} to ${deliveryNoun()}`;
    state.sheetShipping.textContent=shipping;
    state.sheetShipping.classList.toggle('is-free',free);
    state.sheetShipping.hidden=state.checking;
    state.sheetLoading.hidden=!state.checking;
    state.sheetLoading.textContent='Checking your bag…';
    state.sheetTotal.textContent=money(state.cart.total_price,state.cart);
    state.continueLink.href=state.checkoutURL || route('checkout');
    const busy=bagBusy(state);
    state.continueLink.textContent=busy?'Updating bag…':'Continue to checkout';
    state.continueLink.setAttribute('aria-disabled',String(busy));
    state.dialog.querySelectorAll('[data-hbr-sheet-close],[data-hbr-continue-shopping]').forEach(button=>{button.disabled=busy;});
    state.shoppingButton.hidden=!config.enable;
    state.shoppingButton.disabled=busy;state.browseButton.disabled=busy;
    const undo=state.bagNotice.querySelector('button');if(undo)undo.disabled=busy;
    renderSheetProgress(state);
  }
  function closedSheet(state,restoreFocus=true) {
    state.checkoutVersion++;state.checking=false;state.openId='';state.hoverId='';
    state.sheetProgress.hidden=true;
    if(activeSheet===state){activeSheet=null;document.documentElement.removeAttribute('data-hbr-extras-open');}
    if(state.cart)renderForecast(state);
    if(restoreFocus) {
      const trigger=state.checkoutTrigger?.isConnected && !state.checkoutTrigger.hidden?state.checkoutTrigger:state.drawer.querySelector('.hbr-cart-drawer__checkout');
      trigger?.focus({preventScroll:true});
    }
  }
  function closeSheet(state,restoreFocus=true) {
    if(state.dialog.open)state.dialog.close();
    closedSheet(state,restoreFocus);
  }
  function goCheckout(state) {
    if(bagBusy(state))return;
    const url=state.checkoutURL || route('checkout');
    closeSheet(state,false);
    window.location.assign(url);
  }
  async function openSheet(state,trigger) {
    if(activeSheet || bagBusy(state))return;
    const fromCheckout=trigger.matches('.hbr-cart-drawer__checkout');
    state.checkoutURL=state.drawer.querySelector('.hbr-cart-drawer__checkout')?.href || route('checkout');state.checkoutTrigger=trigger;
    state.openId='';state.hoverId='';state.browseOrder=null;state.confirmation=null;paintBagNotice(state);
    state.error='';state.notice='';state.checking=true;
    const ticket=++state.checkoutVersion;
    const stillOpen=()=>state.dialog.open && state.checkoutVersion===ticket;
    const unavailable=()=>fromCheckout?goCheckout(state):closeSheet(state);
    activeSheet=state;
    try {state.dialog.showModal();} catch {activeSheet=null;state.checking=false;if(fromCheckout)window.location.assign(state.checkoutURL);return;}
    rememberPrompt(true);
    document.documentElement.setAttribute('data-hbr-extras-open','');
    renderExtras(state);state.sheetTitle.focus({preventScroll:true});
    state.sheetBody.scrollTop=0;state.rail.parentElement.scrollTop=0;state.browseTop=0;
    try {
      const cart=await readCart();
      if(!stillOpen())return;
      state.uncertain=false;
      publish(cart);
      if(!stillOpen())return;
      if(!cart.items.length || fromCheckout && isFree(cart)){unavailable();return;}
      await ensureCatalogue(state);
      if(!stillOpen())return;
      // An empty tag, unavailable stock or discovery failure must never block checkout.
      if(state.catalogueFailed || !availableChoices(state).length){unavailable();return;}
    } catch {
      if(stillOpen())unavailable();
    } finally {
      if(stillOpen()){state.checking=false;renderExtras(state);}
    }
  }
  function bindSheet(state) {
    state.dialog.addEventListener('cancel',event=>{
      event.preventDefault();if(!bagBusy(state))closeSheet(state);
    });
    state.dialog.addEventListener('close',()=>{
      // close() dispatches asynchronously. Ignore a previous close after reopening.
      if(!state.dialog.open && activeSheet===state)closedSheet(state);
    });
    state.dialog.addEventListener('click',event=>{
      if(event.target.closest('[data-hbr-continue-shopping]')){event.preventDefault();continueShopping(state);return;}
      if(event.target.closest('[data-hbr-sheet-close]') || event.target===state.dialog) {
        event.preventDefault();if(!bagBusy(state))closeSheet(state);
      }
    });
    state.continueLink.addEventListener('click',event=>{
      if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        if(bagBusy(state))event.preventDefault();return;
      }
      event.preventDefault();goCheckout(state);
    });
  }
  function mount(drawer,items) {
    const body=items.closest('.hbr-cart-drawer__body');if(!body)return null;
    const progress=document.createElement('div');progress.className='hbr-bag__delivery';progress.dataset.hbrBagDelivery='';progress.hidden=true;
    progress.innerHTML=`<p class="hbr-bag__delivery-heading" aria-live="polite" aria-atomic="true"><span class="hbr-bag__almost">almost there…</span><span class="hbr-bag__delivery-copy"></span></p><div class="hbr-bag__track-area"><div class="hbr-bag__track" role="progressbar" aria-label="${escape(freeDeliveryCopy())} progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span class="hbr-bag__fill"></span><span class="hbr-bag__forecast"></span></div><span class="hbr-bag__van" aria-hidden="true">${VAN}</span><span class="hbr-bag__goal" aria-hidden="true">${GIFT}</span></div>`;
    const bagNotice=document.createElement('p');bagNotice.className='hbr-bag__confirmation';bagNotice.setAttribute('role','status');bagNotice.setAttribute('aria-live','polite');bagNotice.tabIndex=-1;bagNotice.hidden=true;
    const browseButton=document.createElement('button');browseButton.type='button';browseButton.className='hbr-bag__browse';browseButton.textContent='Browse little extras';browseButton.hidden=true;
    const shoppingButton=document.createElement('button');shoppingButton.type='button';shoppingButton.className='hbr-bag__continue-shopping';shoppingButton.dataset.hbrContinueShopping='';shoppingButton.textContent='Continue shopping';shoppingButton.hidden=true;
    const extras=document.createElement('section');extras.className='hbr-bag__extras';extras.dataset.hbrBagExtras='';extras.hidden=true;
    const id=`hbr-bag-extras-${++sequence}`;extras.setAttribute('aria-label','Little extras');
    extras.innerHTML=`<div class="hbr-bag__carousel" id="${id}-scroll" role="region" aria-label="Little extras, scroll for more" tabindex="0"><div class="hbr-bag__rail" id="${id}-rail"></div></div><div class="hbr-bag__option-panel" id="${id}-panel" role="group" hidden></div>`;
    const status=document.createElement('p');status.className='hbr-bag__status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');status.tabIndex=-1;status.hidden=true;
    // A native dialog outside the drawer cooperates with its existing focus trap.
    const dialog=document.createElement('dialog');dialog.className='hbr-extras-sheet';
    dialog.setAttribute('aria-labelledby',`${id}-title`);dialog.setAttribute('aria-describedby',`${id}-copy`);
    dialog.innerHTML=`<div class="hbr-extras-sheet__frame"><div class="hbr-extras-sheet__head"><div class="hbr-extras-sheet__nav"><button type="button" data-hbr-sheet-close class="hbr-extras-sheet__back"><span aria-hidden="true">‹</span> Back to bag</button><button type="button" data-hbr-sheet-close class="hbr-extras-sheet__close" aria-label="Close little extras and return to bag">×</button></div><header class="hbr-extras-sheet__header"><h2 id="${id}-title" tabindex="-1"></h2><p id="${id}-copy" class="hbr-extras-sheet__copy"></p><div class="hbr-extras-sheet__progress hbr-bag__delivery" hidden><p class="hbr-bag__delivery-heading"><span class="hbr-bag__almost">almost there…</span><span class="hbr-extras-sheet__shipping hbr-bag__delivery-copy"></span></p><div class="hbr-bag__track-area"><div class="hbr-bag__track" role="progressbar" aria-label="${escape(freeDeliveryCopy())} progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span class="hbr-bag__fill"></span></div><span class="hbr-bag__van" aria-hidden="true">${VAN}</span><span class="hbr-bag__goal" aria-hidden="true">${GIFT}</span></div></div><p class="hbr-extras-sheet__loading" role="status" hidden></p></header></div><div class="hbr-extras-sheet__body"></div><button type="button" class="hbr-extras-sheet__scroll-hint" aria-controls="${id}-scroll" hidden>Scroll for more extras <span aria-hidden="true">↓</span></button><footer class="hbr-extras-sheet__footer"><p aria-live="polite" aria-atomic="true"><span>Bag subtotal</span><span data-hbr-sheet-total></span></p><a class="hbr-extras-sheet__continue" href="${escape(route('checkout'))}">Continue to checkout</a></footer></div>`;
    browseButton.setAttribute('aria-haspopup','dialog');browseButton.setAttribute('aria-controls',id);dialog.id=id;
    const sheetBody=dialog.querySelector('.hbr-extras-sheet__body');sheetBody.append(extras);dialog.querySelector('.hbr-extras-sheet__footer').prepend(status);
    body.prepend(progress,bagNotice);items.after(browseButton);drawer.querySelector('.hbr-cart-drawer__checkout')?.after(shoppingButton);document.body.append(dialog);
    const state={id,drawer,items,body,progress,extras,status,dialog,sheetBody,bagNotice,browseButton,shoppingButton,confirmation:null,
      scrollHint:dialog.querySelector('.hbr-extras-sheet__scroll-hint'),
      sheetTitle:dialog.querySelector('h2'),sheetCopy:dialog.querySelector('.hbr-extras-sheet__copy'),
      sheetShipping:dialog.querySelector('.hbr-extras-sheet__shipping'),sheetLoading:dialog.querySelector('.hbr-extras-sheet__loading'),
      sheetProgress:dialog.querySelector('.hbr-extras-sheet__progress'),
      sheetTotal:dialog.querySelector('[data-hbr-sheet-total]'),continueLink:dialog.querySelector('.hbr-extras-sheet__continue'),
      rail:extras.querySelector('.hbr-bag__rail'),panel:extras.querySelector('.hbr-bag__option-panel'),
      products:[],choices:new Map(),photos:new Map(),personalForms:new Map(),selections:new Map(),pendingBatch:null,addingProductId:'',browseOrder:null,browseTop:0,decorated:[],locks:new Map(),openId:'',hoverId:'',error:'',notice:'',revision:0,lastFree:false,lastTotal:null,source:'',uncertain:false,checking:false,checkoutVersion:0,catalogueReady:false};
    states.set(drawer,state);liveStates.add(state);bindExtras(state);bindSheet(state);
    browseButton.addEventListener('click',()=>openSheet(state,browseButton));
    state.scrollHint.addEventListener('click',()=>{
      const scroller=state.openId?state.sheetBody:state.rail.parentElement;
      scroller.scrollTo({top:scroller.scrollTop+scroller.clientHeight*.8,behavior:reduced.matches?'auto':'smooth'});
    });
    state.rail.parentElement.addEventListener('scroll',()=>updateScrollHint(state),{passive:true});
    state.sheetBody.addEventListener('scroll',()=>updateScrollHint(state),{passive:true});
    shoppingButton.addEventListener('click',()=>continueShopping(state));
    bagNotice.addEventListener('click',event=>{
      if(!event.target.closest('[data-hbr-extra-undo]') || bagBusy(state))return;
      const remove=undoButton(state);if(!remove || remove.disabled)return;
      state.confirmation=null;paintBagNotice(state);
      // Reuse the drawer's remove action, including its cart refresh and gift-box handling.
      remove.click();
    });
    if(window.ResizeObserver){state.resize=new ResizeObserver(()=>{fitPreviews();requestAnimationFrame(()=>updateScrollHint(state));});state.resize.observe(drawer);state.resize.observe(state.sheetBody);}
    state.observer=new MutationObserver(records=>{
      if(records.some(r=>r.target===drawer)) {
        fitPreviews();
        if(!drawer.classList.contains('is-open') && state.confirmation){state.confirmation=null;paintBagNotice(state);}
      }
      if(operation && lockStarted)syncLocks(state);else renderSheet(state);
    });
    state.observer.observe(drawer,{attributes:true,attributeFilter:['class']});
    state.observer.observe(items,{attributes:true,attributeFilter:['aria-busy']});
    return state;
  }
  async function ensureCatalogue(state,force=false) {
    const key=sourceKey(state.cart);
    if(state.loadingKey===key)return state.catalogueJob;
    state.loadingKey=key;
    const job=(async()=>{
      try {
        const products=await loadCatalogue(state.cart,force);
        if(sourceKey(state.cart)!==key || !state.drawer.isConnected)return;
        state.products=products;state.catalogueReady=true;state.catalogueFailed=false;
        if(state.catalogueError){state.error='';state.catalogueError=false;}
        renderExtras(state);
      } catch {
        if(sourceKey(state.cart)!==key)return;
        state.catalogueReady=true;state.catalogueFailed=true;state.catalogueError=true;state.failureExpires=Date.now()+60000;
        state.error='Little extras could not load just now.';renderExtras(state);
      } finally {
        if(state.loadingKey===key)state.loadingKey='';
      }
    })();
    state.catalogueJob=job;return job;
  }
  function syncLocks(state) {
    // Lock only ordinary bag actions while our single cart write is in flight.
    // Gift-box and accelerated-checkout code remain owned by their add-ons.
    const nodes=[...state.extras.querySelectorAll('button,input,select')];
    if(lockStarted)nodes.push(...state.drawer.querySelectorAll('[data-hbr-cart-remove],.hbr-cart-drawer__checkout'));
    if(operation) {
      for(const node of nodes) {
        if(!state.locks.has(node))state.locks.set(node,{disabled:node.disabled,aria:node.getAttribute('aria-disabled')});
        if('disabled' in node)node.disabled=true;
        node.setAttribute('aria-disabled','true');
      }
      state.extras.setAttribute('aria-busy','true');
    } else {
      const cartBusy=state.items.getAttribute('aria-busy')==='true';
      for(const [node,old] of state.locks) {
        if(!node.isConnected)continue;
        if(cartBusy && !state.extras.contains(node))continue;
        if('disabled' in node)node.disabled=!!old.disabled;
        if(old.aria===null)node.removeAttribute('aria-disabled');else node.setAttribute('aria-disabled',old.aria);
      }
      state.locks.clear();state.extras.removeAttribute('aria-busy');
    }
    renderSheet(state);
  }
  async function waitForBag() {
    const start=Date.now();
    while(window.HbrGiftBox?.busy || [...liveStates].some(s=>s.items.getAttribute('aria-busy')==='true') || document.querySelector('.hbr-cart__form[aria-busy="true"]')) {
      if(Date.now()-start>15000)throw new Error('Your bag is still updating. Please try again in a moment.');
      await new Promise(resolve=>setTimeout(resolve,100));
    }
  }
  function publish(cart) {
    if(window.HbrSharedBag?.render){window.HbrSharedBag.mount?.();window.HbrSharedBag.render(cart);}
    else throw new Error('Please reload the page to see your updated bag.');
  }
  function replaceProduct(state,fresh) {
    const previous=state.products.find(p=>String(p.id)===String(fresh.id));
    // Ajax product options do not carry Liquid's native swatch colours.
    const product={...previous,...fresh,options:optionsOf(fresh).map(option=>{
      const old=optionsOf(previous).find(o=>o.name===option.name);
      return {...option,values:old?.values||option.values};
    })};
    for(const s of liveStates)if(sourceKey(s.cart)===sourceKey(state.cart))s.products=s.products.map(p=>String(p.id)===String(product.id)?product:p);
    const cached=catalogues.get(sourceKey(state.cart));
    if(cached)cached.products=cached.products.map(p=>String(p.id)===String(product.id)?product:p);
    return product;
  }
  const propertiesKey = properties => JSON.stringify(Object.entries(properties || {}).filter(([key,value])=>key!=='_hbr_little_extra' && value!=null && String(value)!=='').map(([key,value])=>[key,String(value)]).sort(([a],[b])=>a.localeCompare(b)));
  const sameProperties = (item,properties) => properties===undefined || propertiesKey(item.properties)===propertiesKey(properties);
  const extraCount = (cart,id,properties) => cart.items.filter(item=>Number(item.variant_id||item.id)===id && item.properties?._hbr_little_extra==='1' && sameProperties(item,properties)).reduce((sum,item)=>sum+item.quantity,0);
  function reconcileBatch(state,cart) {
    const batch=state.pendingBatch;if(!batch){publish(cart);return;}
    let added=0,remaining=0;
    const keys=[];
    for(const entry of batch.entries) {
      const delta=Math.min(entry.quantity,Math.max(0,extraCount(cart,entry.id,entry.properties)-entry.before));
      added+=delta;remaining+=entry.quantity-delta;
      if(delta)cart.items.filter(item=>Number(item.variant_id||item.id)===entry.id && item.properties?._hbr_little_extra==='1' && sameProperties(item,entry.properties)).forEach(item=>keys.push(item.key));
      if(delta>=entry.quantity)state.selections.delete(entry.productId);
      else state.selections.set(entry.productId,{...entry,quantity:entry.quantity-delta});
    }
    state.pendingBatch=null;state.uncertain=false;state.openId='';state.hoverId='';
    state.notice=added?`${added} ${added===1?'little extra':'little extras'} added to your bag.`:'';
    if(!remaining)state.error='';
    else if(added)state.error=`${state.notice} Please review the remaining selection; some extras could not be added.`;
    else if(!state.error)state.error='We could not confirm these extras in your bag. Please review your selection before trying again.';
    if(added)state.confirmation={keys,key:added===1 && batch.entries.length===1 && batch.entries[0].before===0?keys[0]:null,snapshot:fingerprint(cart),text:state.notice};
    publish(cart);
    paintBagNotice(state);
  }
  async function addSelected(state) {
    if(operation || state.uncertain || state.checking || !state.dialog.open || !state.selections.size)return;
    const entries=[...state.selections.values()].map(entry=>({...entry,before:extraCount(state.cart,entry.id,entry.properties)}));
    const expected=fingerprint(state.cart);
    let release,submitted=false;
    operation=true;state.error='';state.notice='Adding to your bag…';
    for(const s of liveStates)renderExtras(s);
    try {
      await waitForBag();
      release=window.HbrGiftBox?.begin?.();lockStarted=true;
      for(const s of liveStates)syncLocks(s);
      const latest=await readCart();
      if(fingerprint(latest)!==expected)throw new Error('Your bag has changed. Please review your selection and add again.');
      // Validate every selected item before a single multi-item cart request.
      const freshProducts=await Promise.all(entries.map(entry=>request(`products/${encodeURIComponent(entry.handle)}.js`)));
      for(let index=0;index<entries.length;index++) {
        const entry=entries[index],fresh=replaceProduct(state,freshProducts[index]);
        const variant=eligibleVariants(fresh).find(v=>Number(v.id)===entry.id);
        if(!variant || variant.price!==entry.price) {
          state.selections.delete(entry.productId);
          throw new Error(!variant?`${entry.title} is no longer available in that option. Please choose again.`:`The price of ${entry.title} has changed. Please select it again.`);
        }
        if(personalVariant(fresh,variant) && !entry.properties?.['Name or text'])throw new Error('Please open this extra again and complete its personalisation.');
      }
      state.pendingBatch={entries};submitted=true;
      await request('cart/add.js',{items:entries.map(({id,quantity,properties})=>({id,quantity,properties:{...properties,_hbr_little_extra:'1'}}))});
      reconcileBatch(state,await readCart());
    } catch(error) {
      state.notice='';state.error=error.message || 'Your extras could not be added. Please check your bag.';
      // A lost or rejected response may still have added some items. Reconcile
      // each quantity from Shopify, and never automatically repeat the POST.
      try {
        const latest=await readCart();
        if(submitted && state.pendingBatch)reconcileBatch(state,latest);
        else publish(latest);
      } catch {
        state.uncertain=true;state.error='We could not refresh your bag. Please refresh it here before adding again.';
      }
    } finally {
      try {release?.();} finally {
        const addedProductId=state.addingProductId;
        state.addingProductId='';operation=false;lockStarted=false;
        for(const s of liveStates){syncLocks(s);renderExtras(s);}
        paintStatus(state);
        if(state.error)state.status.focus({preventScroll:true});
        else (state.rail.querySelector(`[data-focus="choose-${addedProductId}"]`)||state.continueLink).focus({preventScroll:true});
      }
    }
  }
  function update(cart,drawer) {
    if(!drawer || !Array.isArray(cart?.items) || amount(cart.total_price)===null)return;
    const items=drawer.querySelector('[data-hbr-cart-items]');if(!items)return;
    const state=states.get(drawer)||mount(drawer,items);if(!state)return;
    state.cart=cart;state.revision++;
    if(!cart.items.length){rememberPrompt(false);state.confirmation=null;if(!operation)state.selections.clear();}
    if(!operation)state.notice='';
    if(!operation && !cart.items.length && !state.uncertain){state.error='';state.catalogueFailed=false;}
    drawer.toggleAttribute('data-hbr-bag-enabled',config.enable);
    const key=sourceKey(cart);
    if(state.source!==key){state.source=key;state.products=[];state.choices.clear();state.photos.clear();state.personalForms.clear();state.selections.clear();state.pendingBatch=null;state.openId='';state.hoverId='';state.catalogueReady=false;state.catalogueFailed=false;}
    decorateLines(state);renderProgress(state);paintBagNotice(state);renderExtras(state);syncLocks(state);
    if(!config.enable || !config.showExtras){if(state.dialog.open)closeSheet(state);state.error='';state.notice='';paintStatus(state);if(!config.enable)return;}
    if(config.showExtras && cart.items.length)ensureCatalogue(state);
  }
  window.HbrBagUpgrade={update,get busy(){return operation;}};
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.('.hbr-cart-drawer__checkout');
    if(!trigger || event.defaultPrevented || event.button>0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    const state=states.get(trigger.closest('[data-hbr-cart-drawer]'));
    if(!state || !config.enable || !config.showExtras || typeof state.dialog.showModal!=='function')return;
    if(bagBusy(state) || trigger.getAttribute('aria-disabled')==='true'){event.preventDefault();return;}
    if(!state.cart.items.length || isFree(state.cart) || hasSeenPrompt())return;
    const cached=catalogues.get(sourceKey(state.cart));
    if(state.catalogueFailed && state.failureExpires>Date.now() || state.catalogueReady && cached?.expires>Date.now() && !availableChoices(state).length)return;
    event.preventDefault();openSheet(state,trigger);
  },true);
  document.fonts?.ready.then(fitPreviews);
  document.fonts?.addEventListener('loadingdone',fitPreviews);
  window.addEventListener('resize',fitPreviews,{passive:true});
  document.addEventListener('shopify:section:load',()=>{
    config=readConfig();catalogues.clear();
    for(const state of liveStates)update(state.cart,state.drawer);
  });
  // Most renders arrive through the two theme hooks. Also initialise when this
  // deferred asset loads after an already-open bag or an editor section reload.
  if(document.querySelector('[data-hbr-cart-items] .hbr-cart-drawer__item')) {
    readCart().then(cart=>{
      document.querySelectorAll('[data-hbr-cart-drawer]').forEach(drawer=>{if(!states.has(drawer))update(cart,drawer);});
    }).catch(()=>{});
  }
})();